import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { AwesomeIcon, Box, Link } from '@hover/blueprint';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components';

import { Button } from 'src/shared/components';
import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

import { CallToActionButton } from '../CallToActionButton';
import { NavigationLink } from '../NavigationLink';

interface MobileProps {
  links: NavigationLink[];
}

const Menu = styled(Box)`
  background: #fffffff2;
`;

const MenuLink = styled(Link)`
  align-items: center;
  display: grid;
  justify-content: center;
  min-height: 2rem;
  width: 100%;
`;

const Mobile = ({ links }: MobileProps) => {
  const [isOpen, beOpen] = useState(false);
  const history = useHistory();

  const t = useTranslate(TranslationNamespace.COMMON);

  const onMenuButtonPressed = () => beOpen(!isOpen);

  useEffect(() => history.listen(() => beOpen(false)), [beOpen, history]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflowY = 'hidden';
    }

    return () => {
      document.body.style.overflowY = '';
    };
  }, [isOpen]);

  const conditionals = isOpen
    ? {
        menuButtonLabel: t('navigation.closeNavigationMenu'),
        icon: faTimes,
      }
    : {
        menuButtonLabel: t('navigation.openNavigationMenu'),
        icon: faBars,
      };

  return (
    <Box display={{ base: 'grid', tablet: 'none' }}>
      <Button
        fill="minimal"
        label={conditionals.menuButtonLabel}
        onPress={onMenuButtonPressed}
        shape="square"
      >
        <AwesomeIcon icon={conditionals.icon} />
      </Button>
      {isOpen && (
        <Menu
          alignContent="start"
          bottom={0}
          display="grid"
          gridAutoFlow="row"
          gridRowGap={400}
          gridTemplateRows={`repeat(${links.length + 1}, auto)`}
          justifyItems="center"
          left={0}
          overflowY="auto"
          position="fixed"
          right={0}
          top={1000}
          zIndex={100}
        >
          {links.map(({ label, path }: NavigationLink) => (
            <MenuLink href={path} key={path}>
              {label}
            </MenuLink>
          ))}
          <CallToActionButton />
        </Menu>
      )}
    </Box>
  );
};

export { Mobile };
